export function formatNumber(num: number, decimals?: number): string {
  let options = {}
  if (decimals != null) {
    options = {
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    }
  }
  return num.toLocaleString('en-US', options)
}

export function formatCurrency(num: number): string {
  return formatNumber(num, 2)
}

// prevent bad floating point ops: 1.11 * 100 = 111.00000000000001
export const meterToCentimeter = (m: number) => Math.round(m * 100)
